<template>
  <div>
    <p class="text-muted">{{ $t("TRAININGS.HELP_LINKS_DESCRIPTION") }}</p>
    <div v-if="loading" class="text-center py-4">
      <img src="/img/loading.gif" style="height: 80px; width: 80px" />
    </div>
    <div
      v-for="topic in help"
      v-else
      :key="topic.context"
      class="border rounded p-3 mb-3"
    >
      <h4 class="mb-0">
        {{ $t(contextKey(topic.context)) }}
        <small class="text-muted ml-1">
          ({{
            $tc("TRAININGS.ROLE_FILES", topic.files.length, {
              count: topic.files.length,
            })
          }})
        </small>
      </h4>
      <small class="d-block text-muted mb-3">
        {{
          $t("TRAININGS.SHOWN_ON", {
            where: $t(contextKey(topic.context, "_WHERE")),
          })
        }}
      </small>
      <training-files-editor
        :files="topic.files"
        :saving="savingContext === topic.context"
        @save="save(topic.context, $event)"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TrainingFilesEditor from "@/components/Trainings/TrainingFilesEditor.vue";
import { helpContextI18nKey } from "@/constants/helpContexts";

export default {
  name: "training-help-links",

  components: { TrainingFilesEditor },

  data() {
    return {
      loading: true,
      savingContext: null,
    };
  },

  computed: {
    ...mapGetters({ help: "trainings/help" }),
  },

  async created() {
    try {
      await this.$store.dispatch("trainings/help");
    } catch (error) {
      this.$notify({
        type: "danger",
        message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
      });
    }
    this.loading = false;
  },

  methods: {
    contextKey: helpContextI18nKey,

    async save(context, fileIds) {
      this.savingContext = context;
      try {
        await this.$store.dispatch("trainings/updateHelp", {
          context,
          fileIds,
        });
        this.$notify({ type: "success", message: this.$t("TRAININGS.SAVED") });
      } catch (error) {
        this.$showRequestError(error);
      }
      this.savingContext = null;
    },
  },
};
</script>
